var map = {
	"./details-1.jpg": 9439,
	"./details-2.jpg": 9925,
	"./employee-fit.webp": 490,
	"./executive-search-services.webp": 1637,
	"./organizational-mapping.webp": 8539,
	"./service-1.jpg": 7000,
	"./service-2.jpg": 9620,
	"./service-3.jpg": 8319,
	"./service-4.jpg": 256,
	"./service-5.jpg": 5472,
	"./service-6.jpg": 623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7787;